/* === WontRip 3D/Animation Effects (Fixed v2) === */
(function() {
  'use strict';
  
  /* --- 1. Parallax scroll on hero background --- */
  const hero = document.querySelector('.wr-hero__bg');
  if (hero) {
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const scrollY = window.pageYOffset;
          const heroH = document.querySelector('.wr-hero')?.offsetHeight || 800;
          if (scrollY < heroH) {
            hero.style.transform = 'translate3d(0,' + (scrollY * 0.35) + 'px,0) scale(1.05)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- 2. Floating particles in CTA section --- */
  const cta = document.querySelector('.wr-cta');
  if (cta) {
    const canvas = document.createElement('canvas');
    canvas.className = 'wr-particles';
    canvas.style.cssText = 'position:absolute;inset:0;z-index:0;pointer-events:none;opacity:0.4;';
    cta.style.position = 'relative';
    cta.insertBefore(canvas, cta.firstChild);

    const ctx = canvas.getContext('2d');
    let particles = [];
    const PARTICLE_COUNT = 30;

    function resize() {
      canvas.width = cta.offsetWidth;
      canvas.height = cta.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < PARTICLE_COUNT; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.5 + 0.5,
        dx: (Math.random() - 0.5) * 0.3,
        dy: (Math.random() - 0.5) * 0.3,
        alpha: Math.random() * 0.5 + 0.2
      });
    }

    function animateParticles() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function(p) {
        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(204,163,82,' + p.alpha + ')';
        ctx.fill();
      });
      requestAnimationFrame(animateParticles);
    }
    animateParticles();
  }

  /* --- 3. Scroll-triggered fade-in for sections --- */
  var animTargets = document.querySelectorAll('.wr-manifesto, .wr-journey, .wr-cta, .wr-categories');
  
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wr-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    animTargets.forEach(function(el) {
      el.classList.add('wr-animate-in');
      observer.observe(el);
    });
  }

  /* Fallback: if sections still hidden after 3s, force-show them */
  setTimeout(function() {
    animTargets.forEach(function(el) {
      if (!el.classList.contains('wr-visible')) {
        el.classList.add('wr-visible');
      }
    });
  }, 3000);

  /* --- 4. Journey path step counter animation --- */
  var journeySteps = document.querySelectorAll('.wr-step__number');
  if ('IntersectionObserver' in window) {
    var stepObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wr-step-animate');
          stepObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    journeySteps.forEach(function(s) { stepObserver.observe(s); });
  } else {
    journeySteps.forEach(function(s) { s.classList.add('wr-step-animate'); });
  }

  /* --- 5. Category cards tilt effect (subtle 3D) --- */
  document.querySelectorAll('.wr-cat-card').forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(600px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) scale(1.02)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(600px) rotateY(0) rotateX(0) scale(1)';
      card.style.transition = 'transform 0.4s ease';
    });
    card.addEventListener('mouseenter', function() {
      card.style.transition = 'transform 0.1s ease';
    });
  });

})();